import React from 'react';
import { Inbox, Archive, MessageSquare } from 'lucide-react';
import type { TabsBarProps } from '../types';

/**
 * Tab navigation bar component
 * Memoized component for tab buttons with counts
 */
export const TabsBar: React.FC<TabsBarProps> = React.memo(
  ({ tabs, activeTab, onTabChange, compactMode = false }) => (
    <div className="border-b border-border bg-card dark:bg-card px-2 py-2 flex gap-1 flex-shrink-0">
      {tabs.map((tab) => (
        <div key={tab.id} className="relative group">
          <button
            onClick={() => onTabChange(tab.id)}
            className={`p-2 rounded-md transition-all duration-200 flex items-center justify-center gap-1 ${
              activeTab === tab.id
                ? 'bg-primary/20 text-primary border border-primary/40'
                : 'bg-muted text-muted-foreground border border-transparent hover:bg-muted/80 hover:border-primary/40'
            }`}
            title={`${tab.label} (${tab.count})`}
          >
            {tab.id === 'active' && <Inbox className="w-4 h-4" />}
            {tab.id === 'archived' && <Archive className="w-4 h-4" />}
            {tab.id === 'all' && <MessageSquare className="w-4 h-4" />}
            {!compactMode && (
              <span className={`text-xs font-semibold px-1 py-0 rounded ${
                activeTab === tab.id
                  ? 'bg-primary/30 text-primary'
                  : 'bg-muted text-muted-foreground'
              }`}>
                {tab.count}
              </span>
            )}
          </button>
        </div>
      ))}
    </div>
  )
);

TabsBar.displayName = 'TabsBar';
